import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 250px !important;

    overflow: ${props => (props?.overflow ? props?.overflow : 'scroll')};
    overflow-x: ${props => (props?.overflowX ? props?.overflowX : 'auto')};
    &::-webkit-scrollbar {
      display: '';
    }
  }
  .ant-tabs-tab {
    padding: 15px !important;
  }
  .ant-tabs-nav {
    width: ${props => (props.width ? props?.width : '30%')} !important;
  }
`
export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const Wrapper = styled(Flex)`
  padding: 20px 20px 20px 0;
  gap: 5px;
`
